module.exports = __webpack_public_path__ + "static/img/截屏2024-08-02 18.11.00.ac386a8c.png";